module.exports = {"body":"<h1>this is a test page.</h1>\n<h3>this is a page test and only a page test.</h3>\n"}


//////////////////
// WEBPACK FOOTER
// ./testPage.md
// module id = 658
// module chunks = 0